<app-nav *ngIf="isLoggedIn() | async"></app-nav>
<app-messages></app-messages>
<router-outlet></router-outlet>